{
	"name": "@cloudflare/vite-plugin",
	"version": "1.33.2",
	"description": "Cloudflare plugin for Vite",
	"keywords": [
		"cloudflare",
		"cloudflare-workers",
		"vite",
		"vite-plugin",
		"workers"
	],
	"homepage": "https://github.com/cloudflare/workers-sdk/tree/main/packages/vite-plugin-cloudflare#readme",
	"bugs": {
		"url": "https://github.com/cloudflare/workers-sdk/issues"
	},
	"license": "MIT",
	"repository": {
		"type": "git",
		"url": "https://github.com/cloudflare/workers-sdk.git",
		"directory": "packages/vite-plugin-cloudflare"
	},
	"files": [
		"dist"
	],
	"type": "module",
	"sideEffects": false,
	"main": "./dist/index.mjs",
	"types": "./dist/index.d.mts",
	"exports": {
		".": {
			"types": "./dist/index.d.mts",
			"import": "./dist/index.mjs"
		}
	},
	"publishConfig": {
		"access": "public"
	},
	"scripts": {
		"build": "tsdown",
		"check:type": "tsc --build",
		"dev": "tsdown --watch",
		"test": "vitest run",
		"test:ci": "pnpm test",
		"test:e2e": "vitest run -c e2e/vitest.config.ts",
		"test:watch": "vitest"
	},
	"dependencies": {
		"@cloudflare/unenv-preset": "workspace:*",
		"miniflare": "workspace:*",
		"unenv": "2.0.0-rc.24",
		"wrangler": "workspace:*",
		"ws": "catalog:default"
	},
	"devDependencies": {
		"@cloudflare/containers-shared": "workspace:*",
		"@cloudflare/mock-npm-registry": "workspace:*",
		"@cloudflare/workers-shared": "workspace:*",
		"@cloudflare/workers-tsconfig": "workspace:*",
		"@cloudflare/workers-types": "catalog:default",
		"@cloudflare/workers-utils": "workspace:*",
		"@remix-run/node-fetch-server": "^0.8.0",
		"@types/node": "catalog:default",
		"@types/semver": "^7.5.1",
		"@types/ws": "^8.5.13",
		"defu": "^6.1.4",
		"get-port": "^7.1.0",
		"magic-string": "^0.30.12",
		"mlly": "^1.7.4",
		"open": "catalog:default",
		"picocolors": "^1.1.1",
		"semver": "^7.7.1",
		"tinyglobby": "catalog:default",
		"tree-kill": "catalog:default",
		"tsdown": "0.16.3",
		"typescript": "catalog:default",
		"vite": "catalog:default",
		"vite-legacy": "npm:vite@7.1.12",
		"vitest": "catalog:default"
	},
	"peerDependencies": {
		"vite": "^6.1.0 || ^7.0.0 || ^8.0.0",
		"wrangler": "workspace:^"
	},
	"workers-sdk": {
		"prerelease": true
	}
}
